import { Routes } from "@angular/router";

export const REPORT_ROUTES: Routes = [
  {
    path: "sla-compliance",
    loadComponent: () =>
      import("./pages/sla-compliance/sla-compliance.component").then(
        (m) => m.SlaComplianceComponent,
      ),
    title: "SLA Compliance - Foresight",
    data: {
      breadcrumb: "Reports",
      breadcrumbModule: "Reports",
      breadcrumbTrail: [{ label: "SLA Compliance", reload: true }],
    },
  },
  {
    path: "volumes-revenue",
    loadComponent: () =>
      import("./pages/volumes-revenue/volumes-revenue.component").then(
        (m) => m.VolumesRevenueComponent,
      ),
    title: "Order Volumes & Revenue - Foresight",
    data: {
      breadcrumb: "Reports",
      breadcrumbModule: "Reports",
      breadcrumbTrail: [{ label: "Order Volumes & Revenue", reload: true }],
    },
  },
  {
    path: "inventory-reconciliation",
    loadComponent: () =>
      import("./pages/inventory-reconciliation/inventory-reconciliation.component").then(
        (m) => m.InventoryReconciliationComponent,
      ),
    title: "Inventory Reconciliation - Foresight",
    data: {
      breadcrumb: "Reports",
      breadcrumbModule: "Reports",
      breadcrumbTrail: [{ label: "Inventory Reconciliation", reload: true }],
    },
  },
  { path: "", redirectTo: "sla-compliance", pathMatch: "full" },
];
